// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__Yo7UC","label":"Labeled_label__lKxMN","divider":"Labeled_divider__3YHOd"};